import script from "./QuickBuyOrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickBuyOrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./QuickBuyOrderDetails.vue?vue&type=style&index=0&id=ab60b25a&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab60b25a"]])

export default __exports__